<!--
Created on 2021-04-16
Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
Unauthorized copying of this file, via any medium is strictly prohibited
Proprietary and confidential
Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-16
-->
<template>
  <div id="modal-pin" class="menu menu-box-modal rounded-m p-2 bg-highlight" data-menu-width="310">
    <div class="content pt-1 pb-1">
      <h1 class="mb-1 color-white font-700 text-center">{{ title || 'Zadajte PIN' }}</h1>
      <div class="boxed-text-xl color-white opacity-80">
        <div class="keyboard mb-0 mt-4">
          <div class="pin">
            <div class="pin-element" :class="{ 'active': pin.length > 0 }"></div>
            <div class="pin-element" :class="{ 'active': pin.length > 1 }"></div>
            <div class="pin-element" :class="{ 'active': pin.length > 2 }"></div>
            <div class="pin-element" :class="{ 'active': pin.length > 3 }"></div>
          </div>
          <p class="color-white px-2 m-0 mt-n3" >{{ message }}</p>
          <div class="row m-0">
            <div v-for="index in 3" :key="index" class="col-4 p-0 m-0">
              <div @click="if(pin.length < 4) pin = pin + index;" class="key">{{ index }}</div>
            </div>
          </div>
          <div class="row m-0">
            <div v-for="index in 3" :key="index" class="col-4 p-0 m-0">
              <div @click="if(pin.length < 4) pin = pin + (index + 3);" class="key">{{ index + 3 }}</div>
            </div>
          </div>
          <div class="row m-0">
            <div v-for="index in 3" :key="index" class="col-4 p-0 m-0">
              <div @click="if(pin.length < 4) pin = pin + (index + 6);" class="key">{{ index + 6 }}</div>
            </div>
          </div>
          <div class="row m-0">
            <div class="col-4 p-0 m-0">
              <div @click="if(pin.length > 0) pin = pin.slice(0, -1);" class="key"><i class="fa fa-chevron-left"></i></div>
            </div>
            <div class="col-4 p-0 m-0">
              <div @click="if(pin.length < 4) pin = pin + '0';" class="key">0</div>
            </div>
            <div class="col-4 p-0 m-0">
              <div @click="pin = ''" class="key"><i class="fa fa-times"></i></div>
            </div>
          </div>
        </div>
      </div>
      <button @click.stop.prevent="$emit('update:modelValue', pin);$emit('onEnter')" class="mt-4 btn close-menu btn-s shadow-l bg-white color-black font-900 btn-center-m mb-2" :disabled="(pin || '').length != 4">{{ btnTitle || 'ĎALEJ' }}</button>
    </div>            
  </div>    
</template>

<script>
import { ref } from 'vue'

export default {
  name: 'PinModal',
  props: {
    modelValue: String,
    title: String,
    btnTitle: String,
    message: String,
  },
  setup(props) {
    const pin = ref(props.modelValue)

    return {
      pin
    }
  },
  watch: {
    modelValue: function (value) {
      this.pin = value
    },
  }
}
</script>

<style>
.keyboard .key{
display: inline-block;
margin: 8px;
border-radius: 45px;
padding: 0px;
background-color: rgba(0,0,0,0);
color: white;
width: 45px;
height: 45px;
text-align: center;
line-height: 45px;
border: 1px solid rgba(255,255,255,0.5);
text-decoration: none;
animation-name: key-hover-out;
animation-duration: 0.3s;
font-size: 1.1rem;
}
.keyboard .key:visited {
color: white;
}
.keyboard .key:active{
background-color: rgba(255,255,255,0.5);
animation-name: key-hover-in;
animation-duration: 0.3s;
color: white;
}
@keyframes key-hover-in {
from {background-color: rgba(0,0,0,0);}
to {background-color: rgba(255,255,255,0.5)}
}
@keyframes key-hover-out {
from {background-color: rgba(255,255,255,0.5)}
to {background-color: rgba(0,0,0,0)}
}
.keyboard .key-center{
display: block;
margin-left: auto;
margin-right: auto;
}
.keyboard .key-row{
margin: 0px;
padding: 0px;
}
.keyboard{
padding: 0px;
margin: auto;
width: 200px;
}
.keyboard .pin{
text-align: center;
margin-bottom: 15px;
}
.keyboard .pin-element{
display: inline-block;
margin: 5px;
width: 8px;
height: 8px;
border-radius: 8px;
border: 1px solid rgba(255,255,255,0.5);
}
.keyboard .pin-element.active{
background-color:  rgba(255,255,255,0.5);
}
</style>